import Vue from 'vue'
import App from './App.vue'
// import store from './store'
import VueDraggableResizable from 'vue-draggable-resizable'

Vue.component('vue-draggable-resizable', VueDraggableResizable);
Vue.config.productionTip = false

new Vue({
  // store,
  render: h => h(App)
}).$mount('#etv-dressing-room')
